import { compose, mdsWidget } from 'dojo/_base/declare';

import FinderBaseV2 from '../FinderBase/FinderBaseV2';
import lang from 'dojo/_base/lang';
import TempInvoiceView from './TempInvoiceView';
import { TempInvoiceFinderProject } from "./TempInvoiceTypes";

class TempInvoiceConfirmationFinder extends compose(FinderBaseV2) {

    private _onClickRow(row: StaticTable.StaticTableRow<any>) {
        let entity = row.rowGroup.entity;
        //let editor = new TempInvoiceConfirmationEditor();

        let view = new TempInvoiceView();
        view.setup(entity.ID, entity.$Displayname, entity, { parent: this }, "tempInvoiceConfirmationView", this.getTabContainerName());
        
        //editor.setup(entity, this.getTabContainerName());
    }

    private _tableFormatter(cell: StaticTable.StaticTableCell<TempInvoiceFinderProject>) {
        return false;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setupFinderWithCallfunctions(
            "Webtool_API__TempInvoiceConfirmationFinder_GetConfig",
            "Webtool_API__TempInvoiceConfirmationFinder_GetResults",
            lang.hitch(this, this._onClickRow),
            lang.hitch(this, this._tableFormatter),
        );
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TempInvoiceConfirmationFinder);